import styled, { createGlobalStyle } from 'styled-components'

export const SimpleMessagePageGlobalStyle = createGlobalStyle`
  #wrapper > section.iframe > .simple-message.iframe,
  #wrapper > section.nemi > .simple-message.nemi {
    background: none;
  }
`

export default styled.article`
  display: flex;
  height: 100%;
  width: 100vw;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  box-sizing: border-box;

  .text-container {
    width: 100%;
    max-width: 515px;
    padding: 70px 80px;
    box-sizing: border-box;
    align-items: stretch;
    justify-content: center;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .title {
      text-align: center;
      font-size: 28px;
      line-height: normal;
      font-weight: bold;
      color: ${ ({ theme }) => theme.colors.accentDark };
    }
  }

  @media screen and (max-width: 768px) {
    .text-container {
      padding: 40px 24px;
    }

    .text-container .title {
      font-size: 24px;
    }
  }
`
